<template>
  <div>
    <div class="derecha">
      <el-select
        v-model="value"
        placeholder="Proveerdor"
        @change="handleSelectChange"
        clearable
        filterable
        allow-create
        class="selector"
        default-first-option
      >
        <el-option
          v-for="itemopt in options"
          :key="itemopt.value"
          :label="itemopt.nombre"
          :value="itemopt.nombre"
        >
        </el-option>
      </el-select>
      <rabbey-toolbox
        :filterables="true"
        @filter-search="handleSearch"
      ></rabbey-toolbox>
    </div>
    <el-button class="boton" type="primary" @click="notifica" round
      >Activar</el-button
    >

    <rabbey-table-3
      :checkBox="true"
      ref="table"
      :loading="loading"
      :data="items"
      :columns="columnsDetails"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    />
  </div>
</template>
<style>
.el-table .success-row {
  background: #7bff00;
}
.derecha {
  text-align: right;
  position: relative;
}
.boton {
  text-align: left;
  position: relative;
}
.selector {
  width: 500px;
  position: relative;
}
</style>
<script>
export default {
  data() {
    return {
      search: "",

      page: 1,
      limit: 1000,
      totalItems: 0,
      pageSizes: [10, 30, 50, 100, 600],
      date: "",
      dialogVisible: false,
      buttonLoading: false,
      drawer: false,
      loading: false,
      items: [],
      itemssave: [],
      ItemsCheck: [],
      options: [],
      ItemsCheckedfromDb: [],
      columnsDetails: [
        {
          prop: "Status",
          label: "Notificaciones",
          width: 120
        },

        {
          prop: "nombre",
          label: "Nombre",
          width: 300
        },
        {
          prop: "correo",
          label: "Email",
          width: 300
        },
        {
          prop: "empresa_nombre",
          label: "Empresa",
          width: 500
        },
        {
          prop: "codigo",
          label: "Codigo Navition",
          width: 500
        },
        {
          prop: "tipo",
          label: "Tipo Usuario",
          width: 110
        },
        {
          prop: "status2",
          label: "Estatus Cliente",
          width: 120
        }
      ]
    };
  },

  created() {
    this.getempresas();
    this.fecthCustomers2();
    this.getActiveIndex();
  },

  methods: {
    tableRowClassName({ row }) {
      if (row.Status == "ACT") {
        return "success-row";
      }
    },

    handleSelectChange(selectedValue) {
      if (selectedValue) {
        this.items = this.items.filter(
          (lista) => lista.empresa_nombre == selectedValue
        );
      } else {
        this.items = this.itemssave;
      }
    },

    getempresas() {
      this.$http
        .get("/api/tennos/GetEmpresasNcf", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CompanyId: this.currentCompany
          }
        })
        .then((resp) => {
          this.options = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fecthCustomers2() {
      this.items = [];
      this.loading = true;
      this.$http
        .get("/api/tennos/GetUsuariosByEmpresas", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CompanyId: this.currentCompany
          }
        })
        .then((resp) => {
          const { CurrentPage } = resp.data;

          this.items = resp.data;
          this.totalItems = resp.data;
          this.page = CurrentPage;
          this.itemssave = this.items;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.Checked = [];
      if (val.length <= 0) {
        this.Checked = [];
      } else {
        val.forEach((value) => {
          const { usuarioid, nombre, Status, correo, codigo } = value;

          this.Checked.push({
            usuarioid,
            nombre,
            Status,
            correo,
            codigo
          });
        });
        this.ItemsCheck = this.Checked;
      }
    },
    updatestatus(id, estatus) {
      this.$http
        .put("/api/tennos/UpdateStatusNoti/" + id + "/" + estatus + "")
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    notifica() {
      this.ItemsCheck.forEach((value) => {
        let usuario = {};
        usuario.Id_Usuario = value.usuarioid;
        usuario.Nombre = value.nombre;
        usuario.Correo = value.correo;
        usuario.Status = "ACT";
        usuario.codigo = value.codigo;
        if (value.Status == "ACT") {
          this.updatestatus(value.usuarioid, "INA");
          this.fecthCustomers2();
        } else if (value.Status == "INA") {
          this.updatestatus(value.usuarioid, "ACT");
          this.fecthCustomers2();
        } else if (value.Status == null) {
          this.$http
            .post("/api/tennos/PostNotification", usuario)
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
          this.fecthCustomers2();
        }
      });
    },
    handleSearch(search) {
      this.search = search;
      if (this.search == "") {
        this.fecthCustomers2();
      } else {
        this.filtrar(this.search);
      }
    },

    handleCurrentPage(page) {
      this.page = page;

      this.fecthCustomers2();
    },
    handleFilters() {
      this.getempresas();
    },
    handlePageSize(limit) {
      this.limit = limit;

      this.fecthCustomers2();
    },
    filtrar(search) {
      if (search != "") {
        this.items = this.items.filter((lista) =>
          lista.correo.toLowerCase().includes(search.toLowerCase())
        );
      }
    }
  }
};
</script>
